const localization = {
  Admin: {
    en: {
      pageName: "Admin page",
      logoutConfirm: "Do you really want to log out?",
    },
    de: {
      pageName: "Administrator Seite",
      logoutConfirm: "Möchten Sie sich wirklich abmelden?",
    },
  },

  YesNoModal: {
    en: {
      yes: "Yes",
      no: "No",
    },
    de: { yes: "Ja", no: "Nein" },
  },

  AdminEditRecords: {
    en: {
      pageTitle: "Edit Records",
      totalDuration: "Total duration",
      start: "Start editing",
      stop: "Stop editing",
      filterBy: "Filter by",
      filterItems: [
        "Activity Type",
        "Services",
        "Forms",
        "Users",
        "Teams",
        "Billable",
        "Finalized",
        "From date",
        "To date",
      ],

      first: "First",
      previous: "Previous",
      next: "Next",
      last: "Last",
      page: "Page",
      of: "of",
      items: "items",

      tableHeaders: [
        "Activity Type",
        "Service",
        "Form",
        "Phone Number",
        "Info",
        "Line",
        "Billable",
        "Time",
        "Duration",
      ],

      activityTypes: [
        { name: "Offline Activity", id: 1 },
        { name: "Incoming Call", id: 2 },
        { name: "Outgoing Call", id: 3 },
        { name: "Idle", id: 4 },
        { name: "Wrap-up", id: 5 },
        { name: "Internal incoming call", id: 6 },
        { name: "Internal outgoing call", id: 7 },
      ],
      FormSavedMessage: "Form saved successfully",

      billableTypes: [
        {
          name: "Billable/Not Billable",
          value: null,
        },
        {
          name: "Billable",
          value: true,
        },
        {
          name: "Not Billable",
          value: false,
        },
      ],
      finalizedTypes: [
        {
          name: "Finalized/Not Finalized",
          value: null,
        },
        {
          name: "Finalized",
          value: true,
        },
        {
          name: "Not finalized",
          value: false,
        },
      ],
      yesText: "Start editing",
      noText: "Cancel",
      title: "Start editing",
      reason: "Editing reason",
    },

    de: {
      pageTitle: "Korrektur Datensätze",
      totalDuration: "Gesamtdauer",
      start: "Bearbeitung beginnen",
      stop: "Bearbeitung beenden",
      filterBy: "Filtern nach",
      FormSavedMessage: "Formular erfolgreich gespeichert",

      filterItems: [
        "Aktivitätstyp",
        "Service",
        "Formular",
        "Benutzer",
        "Teams",
        "Abrechenbar",
        "Abgeschlossen",
        "Start Datum",
        "End Datum",
      ],

      first: "Erste",
      previous: "Zurück",
      next: "Nächste",
      last: "Letzte",
      page: "Seite",
      of: "von",
      items: "Einträge",

      tableHeaders: [
        "Aktivitätstyp",
        "Service",
        "Formular",
        "TELEFONNUMMER",
        "Info",
        "LEITUNG",
        "ABRECHENBAR",
        "ZEIT",
        "DAUER",
      ],
      activityTypes: [
        { name: "OFFLINE-AKTIVITÄT", id: 1 },
        { name: "Eingehendes Telefonat", id: 2 },
        { name: "Ausgehendes Telefonat", id: 3 },
        { name: "Idle", id: 4 },
        { name: "Nacharbeit", id: 5 },
        { name: "Internes Eingehendes Telefonat", id: 6 },
        { name: "Internes Ausgehendes Telefonat", id: 7 },
      ],
      billableTypes: [
        {
          name: "Abrechenbar/Nicht abrechenbar",
          value: null,
        },
        {
          name: "Abrechenbar",
          value: true,
        },
        {
          name: "Nicht abrechenbar",
          value: false,
        },
      ],
      finalizedTypes: [
        {
          name: "Abgeschlossen/Nicht Abgeschlossen",
          value: null,
        },
        {
          name: "Abgeschlossen",
          value: true,
        },
        {
          name: "Nicht Abgeschlossen",
          value: false,
        },
      ],
      yesText: "Beginnen Sie die Bearbeitung",
      noText: "Abbrechen",
      title: "Beginnen Sie die Bearbeitung",
      reason: "Bearbeitungsgrund",
    },
  },

  AdminFormsAndFields: {
    en: {
      pageName: "FORMS AND FIELDS",
      inactive: "Show inactive",
      search: "Search",
      addNew: "Add new form",
    },

    de: {
      pageName: "FORMULARE UND FELDER",
      inactive: "Inaktiv anzeigen",
      search: "Suche",
      addNew: "Neues Formular hinzufügen",
    },
  },

  AdminIntradayView: {
    en: {
      pageTitle: "Intraday View",
      totalDuration: "Total duration",
      start: "Start editing",
      stop: "Stop editing",
      filterBy: "Filter by",
      filterItems: [
        "Activity Type",
        "Services",
        "Forms",
        "Users",
        "Teams",
        "Billable",
        "Finalized",
        "From date",
        "To date",
      ],

      first: "First",
      previous: "Previous",
      next: "Next",
      last: "Last",
      page: "Page",
      of: "of",
      items: "items",

      tableHeaders: [
        "Activity Type",
        "Service",
        "Form",
        "Team",
        "User",
        "User ID",
        "ACD-LOGIN",
        "Billable",
        "Start time",
        "End Time",
        "Duration",
      ],

      activityTypes: [
        { name: "Offline Activity", id: 1 },
        { name: "Incoming Call", id: 2 },
        { name: "Outgoing Call", id: 3 },
        { name: "Idle", id: 4 },
        { name: "Wrap-up", id: 5 },
        { name: "Internal incoming call", id: 6 },
        { name: "Internal outgoing call", id: 7 },
      ],
      billableTypes: [
        {
          name: "Billable/Not Billable",
          value: null,
        },
        {
          name: "Billable",
          value: true,
        },
        {
          name: "Not Billable",
          value: false,
        },
      ],
      finalizedTypes: [
        {
          name: "Finalized/Not Finalized",
          value: null,
        },
        {
          name: "Finalized",
          value: true,
        },
        {
          name: "Not finalized",
          value: false,
        },
      ],
      yesText: "Start editing",
      noText: "Cancel",
      title: "Start editing",
      reason: "Editing reason",
      refresh: "Refresh",
      exportActivities: "Export Activites",
      export: "Export",
    },

    de: {
      pageTitle: "Intraday-Ansicht",
      totalDuration: "Gesamtdauer",
      start: "Beginnen Sie die Bearbeitung",
      stop: "Hören Sie auf zu bearbeiten",
      filterBy: "Filtern nach",
      filterItems: [
        "Aktivitätstyp",
        "Dienstleistungen",
        "Formular",
        "Benutzer",
        "Teams",
        "Abrechenbar",
        "Abgeschlossen",
        "Ab Datum",
        "Zu Datum",
      ],

      first: "Erste",
      previous: "Zurück",
      next: "Nächste",
      last: "Letzte",
      page: "Seite",
      of: "von",
      items: "Einträge",

      tableHeaders: [
        "Aktivitätstyp",
        "Dienstleistungen",
        "Formen",
        "Team",
        "Benutzer",
        "Benutzer ID",
        "ACD-Login",
        "ABRECHENBAR",
        "Startzeit",
        "Endzeit",
        "DAUER",
      ],

      activityTypes: [
        { name: "OFFLINE-AKTIVITÄT", id: 1 },
        { name: "Eingehender Telefonat", id: 2 },
        { name: "Ausgehender Telefonat", id: 3 },
        { name: "Idle", id: 4 },
        { name: "Nacharbeit", id: 5 },
        { name: "Internes Eingehender Telefonat", id: 6 },
        { name: "Internes Ausgehender Telefonat", id: 7 },
      ],
      billableTypes: [
        {
          name: "Abrechenbar/Nicht abrechenbar",
          value: null,
        },
        {
          name: "Abrechenbar",
          value: true,
        },
        {
          name: "Nicht abrechenbar",
          value: false,
        },
      ],
      finalizedTypes: [
        {
          name: "Abgeschlossen/Nicht Abgeschlossen",
          value: null,
        },
        {
          name: "Abgeschlossen",
          value: true,
        },
        {
          name: "Nicht Abgeschlossen",
          value: false,
        },
      ],
      yesText: "Beginnen Sie die Bearbeitung",
      noText: "Stornieren",
      title: "Beginnen Sie die Bearbeitung",
      reason: "Bearbeitungsgrund",
      refresh: "Aktualisieren",
      exportActivities: "Aktivitäten exportieren",
      export: "Export",
    },
  },

  AdminLiveView: {
    en: {
      pageTitle: "Live View",
      totalDuration: "Total duration",
      start: "Start editing",
      stop: "Stop editing",
      filterBy: "Filter by",
      filterItems: [
        "Activity Type",
        "Services",
        "Forms",
        "Users",
        "Teams",
        "Billable",
        "Finalized",
        "From date",
        "To date",
      ],

      first: "First",
      previous: "Previous",
      next: "Next",
      last: "Last",
      page: "Page",
      of: "of",
      items: "items",

      tableHeaders: [
        "Activity Type",
        "Service",
        "Form",
        "Team",
        "User",
        "User ID",
        "ACD-LOGIN",
        "Billable",

        "Duration",
      ],

      activityTypes: [
        { name: "Offline Activity", id: 1 },
        { name: "Incoming Call", id: 2 },
        { name: "Outgoing Call", id: 3 },
        { name: "Idle", id: 4 },
        { name: "Wrap-up", id: 5 },
        { name: "Internal incoming call", id: 6 },
        { name: "Internal outgoing call", id: 7 },
      ],
      billableTypes: [
        {
          name: "Billable/Not Billable",
          value: null,
        },
        {
          name: "Billable",
          value: true,
        },
        {
          name: "Not Billable",
          value: false,
        },
      ],
      finalizedTypes: [
        {
          name: "Finalized/Not Finalized",
          value: null,
        },
        {
          name: "Finalized",
          value: true,
        },
        {
          name: "Not finalized",
          value: false,
        },
      ],
      yesText: "Start editing",
      noText: "Cancel",
      title: "Start editing",
      reason: "Editing reason",
      refresh: "Refresh",
      exportActivities: "Export Activites",
      export: "Export",
    },
    de: {
      pageTitle: "Live-Ansicht",
      totalDuration: "Gesamtdauer",
      start: "Beginnen Sie die Bearbeitung",
      stop: "Hören Sie auf zu bearbeiten",
      filterBy: "Filtern nach",
      filterItems: [
        "Aktivitätstyp",
        "Dienstleistungen",
        "Formular",
        "Benutzer",
        "Teams",
        "Abrechenbar",
        "Abgeschlossen",
        "Ab Datum",
        "Zu Datum",
      ],

      first: "Erste",
      previous: "Zurück",
      next: "Nächste",
      last: "Letzte",
      page: "Seite",
      of: "von",
      items: "Einträge",

      tableHeaders: [
        "Aktivitätstyp",
        "Dienstleistungen",
        "Formen",
        "Team",
        "Benutzer",
        "Benutzer ID",
        "ACD-Login",
        "ABRECHENBAR",

        "DAUER",
      ],

      activityTypes: [
        { name: "OFFLINE-AKTIVITÄT", id: 1 },
        { name: "Eingehender Telefonat", id: 2 },
        { name: "Ausgehender Telefonat", id: 3 },
        { name: "Idle", id: 4 },
        { name: "Nacharbeit", id: 5 },
        { name: "Internes Eingehender Telefonat", id: 6 },
        { name: "Internes Ausgehender Telefonat", id: 7 },
      ],
      billableTypes: [
        {
          name: "Abrechenbar/Nicht abrechenbar",
          value: null,
        },
        {
          name: "Abrechenbar",
          value: true,
        },
        {
          name: "Nicht abrechenbar",
          value: false,
        },
      ],
      finalizedTypes: [
        {
          name: "Abgeschlossen/Nicht Abgeschlossen",
          value: null,
        },
        {
          name: "Abgeschlossen",
          value: true,
        },
        {
          name: "Nicht Abgeschlossen",
          value: false,
        },
      ],
      yesText: "Beginnen Sie die Bearbeitung",
      noText: "Stornieren",
      title: "Beginnen Sie die Bearbeitung",
      reason: "Bearbeitungsgrund",
      refresh: "Aktualisierung",
      exportActivities: "Aktivitäten exportieren",
      export: "Export",
    },
  },

  AdminLob: {
    en: {
      pageName: "LOB Administration",
      add: "Add",
      empty: "No businesses were found. Click add to start creating.",
    },
    de: {
      pageName: "Geschäftsbereich Verwaltung",
      add: "Hinzufügen",
      empty:
        "Es wurden keine Geschäftsbereiche gefunden. Klicken Sie auf „Hinzufügen“ um mit der Erstellung zu beginnen.",
    },
  },

  AdminPhonebook: {
    en: {
      success: "Phone number added sucessfully",
      alreadyExists: "Phone number already exists for another record",
      deletedSuccess: "Phone number deleted sucessfully",
      editedSuccess: "Phone number edited sucessfully",
      pageName: "Phonebook",
      add: "Add",
      name: "Name",
      telephoneNumber: "Telephone Number / Queue ID",
      outboundLine: "Outbound Line",
      lineOfBusiness: "Line Of Business",
      editDelete: "EDIT/DELETE",
      addModalTitle: "Adding a new telephone number",
      cancel: "Cancel",
      add: "Add",
      editingModalTitle: "Editing telephone number",
      confirm: "Confirm",
      deleteModalTitle: "Are you sure you want to delete?",
    },
    de: {
      success: "Telefonnummer erfolgreich hinzugefügt",
      alreadyExists:
        "Die Telefonnummer existiert bereits für einen anderen Datensatz",
      deletedSuccess: "Telefonnummer erfolgreich gelöscht",
      editedSuccess: "Telefonnummer erfolgreich bearbeitet",
      pageName: "Telefonbuch",
      add: "Hinzufügen",
      name: "Name",
      telephoneNumber: "Telefonnummer / Queue ID",
      outboundLine: "Ausgehende Leitung",
      lineOfBusiness: "Geschäftsbereich",
      editDelete: "Bearbeiten / Löschen",
      addModalTitle: "Hinzufügen einer neuen Telefonnummer",
      cancel: "Stornieren",
      add: "Hinzufügen",
      editingModalTitle: "Telefonnummer bearbeiten",
      confirm: "Bestätigen",
      deleteModalTitle:
        "Sind Sie sicher, dass Sie den Eintrag löschen möchten?",
    },
  },

  AdminServices: {
    en: {
      pageName: "SERVICES",
      mainAddButtonRoot: "Add root service",
      mainAddButtonSub: "Add sub-service",
      addModalTitle: "Add a new ",
      rootService: "root service",
      subService: "sub-service",
      serviceName: "Service name",
      serviceNameHint: "Enter service name",
      serviceNameError: "Please provide a valid service name.",
      cancel: "Cancel",
      add: "Add",
    },
    de: {
      pageName: "SERVICES",
      mainAddButtonRoot: "Haupt-Service hinzufügen",
      mainAddButtonSub: "Sub-Service hinzufügen",
      addModalTitle: "Hinzufügen",
      rootService: "root service",
      subService: "sub-service",
      serviceName: "Service Name",
      serviceNameHint: "Geben Sie den Dienstnamen ein",
      serviceNameError: "Bitte geben Sie einen gültigen Dienstnamen an.",
      cancel: "Abbrechen",
      add: "Hinzufügen",
    },
  },

  AdminSettings: {
    en: {
      pageName: "Settings",
      total: "Total Time Hidden",
      totalHint:
        "When selected, day total time and activities count are not displayed for agents",
      restricted: "Restricted Mode",
      restrictedHint:
        "When selected, finished activities are hidden and activity times cannot be changed by agents.",
      overhead: "Overhead can access permitted teams only",
      overheadHint:
        "When selected then data on 'Edit Records','Intraday View' and 'Live View' pages will be restricted by Admin team selection in 'User-to-Team' page.",
      timeZone: "Time Zone",
      display: "Display and edit tracked activities within",
      displayHint:
        "Limits the time in which activities are displayed and available for editing.",
      months: "Months",
      unsaved: "Delete unsaved activities within",
      unsavedHint:
        "Defines the time an unsaved activity is displayed in the system before deletion. Minimum time to be selected is 8 hours. Default time is 12 hours.",
      hours: "Hours",
      cancel: "Cancel",
      save: "Save",
      allowVoice: "Allow voice channel",
    },

    de: {
      pageName: "Einstellungen",
      total: "Tagesgesamtzeit versteckt",
      totalHint:
        "Bei Auswahl dieser Option werden die Tageszeit und die Anzahl der Aktivitäten für Agenten nicht angezeigt.",
      restricted: "Eingeschränkter Modus",
      restrictedHint:
        "Wenn diese Option ausgewählt, ist werden abgeschlossene Aktivitäten ausgeblendet und die Aktivitätszeiten können von Agenten nicht geändert werden.",
      overhead: "Overhead kann nur auf zugelassene Teams zugreifen",
      overheadHint:
        "Wenn diese Option ausgewählt, ist werden die Daten auf den Seiten Korrektur Datensätze, Intraday-Ansicht und Live-Ansicht durch die Auswahl des Admin-Teams auf der User-Team-Zuordnung Seite eingeschränkt.",
      timeZone: "Zeitzone",
      display: "Erfasste Aktivitäten anzeigen und bearbeiten",
      displayHint:
        "Begrenzt die Zeit, in der Aktivitäten angezeigt werden und für die Ausgabe verfügbar sind.",
      months: "Monate",
      unsaved: "Löschen Sie nicht gespeicherte Aktivitäten nach",
      unsavedHint:
        "Definiert die Zeit, bis zu der eine nicht gespeicherte Aktivität vor dem Löschen im System angezeigt wird. Die Mindestauswahlzeit beträgt 8 Stunden. Die Standardzeit beträgt 12 Stunden.",
      hours: "Stunden",
      cancel: "Abbrechen",
      save: "Speichern",
      allowVoice: "Sprachkanal zulassen",
    },
  },

  AdminTeamAdminstration: {
    en: {
      pageName: "Team Administration",
      add: "Add",
      empty: "No businesses were found. Click add to start creating.",
    },
    de: {
      pageName: "Team Administration",
      add: "Hinzufügen",
      empty:
        "Es wurden keine teams gefunden. Klicken Sie auf „Hinzufügen“ um mit der Erstellung zu beginnen.",
    },
  },

  TeamInfo: {
    en: {
      label: "Team name",
      deleteModalTitle: "Are you sure you want to delete this team?",
      deleteModalBody:
        "This team will be deleted immediately. You can't undo this action.",
      cancel: "Cancel",
      delete: "Delete",
      cannotBeEmpty: "Team name cannot be empty",
    },

    de: {
      label: "Team name",
      deleteModalTitle:
        "Sind Sie sicher, dass Sie dieses Team löschen möchten?",
      deleteModalBody:
        "Dieses Team wird sofort gelöscht. Sie können diese Aktion nicht rückgängig machen.",
      cancel: "Abbrechen",
      delete: "Löschen",
      cannotBeEmpty: "Der Teamname darf nicht leer sein",
    },
  },

  AdminTenantIdle: {
    en: {
      successSnackbar: "Successfully added new tenant idle",
      successEditSnackbar: "Edited tenant idle successfully",
      successDeleteSnackbar: "Successfully deleted tenant idle",
      duplicatedIdleCodeSnackbar: "Idle code already in use",
      pageName: "Tenant Idles",
      add: "Add",
      tableHeaders: [
        "NAME",
        "GENESYS IDLE CODE",
        "STOPS ACTIVITY",
        "BILLABLE",
        "EDIT/REMOVE",
      ],
      yes: "Yes",
      no: "No",
      addModalBody: "Adding a new Tenant Idle",
      modalLabels: ["Name", "Genesys Idle Code", "Stops Activity", "Billable"],
      cancel: "Cancel",
      editModalBody: "Edit Tenant Idle",
      confirmEdit: "Confirm Edit",
      deleteModalTitle: "Confirm Delete",
      deleteModalBody: "Are you sure you want to delete?",
      confirm: "Confirm",
    },

    de: {
      successSnackbar: "Neuer Idle hinzugefügt",
      successEditSnackbar: "Idle erfolgreich bearbeitet",
      successDeleteSnackbar: "Idle erfolgreich gelöscht",
      duplicatedIdleCodeSnackbar: "Idle Code wird bereits verwendet",

      pageName: "Mandant Idles",
      add: "Hinzufügen",
      tableHeaders: [
        "NAME",
        "GENESYS IDLE CODE",
        "STOPPT DIE AKTIVITÄT",
        "ABRECHENBAR",
        "BEARBEITEN/ENTFERNEN",
      ],
      yes: "Ja",
      no: "Nein",
      addModalBody: "Fügen Sie einen neuen Mandant Idle hinzu",
      modalLabels: [
        "Name",
        "Genesys Idle Code",
        "Stoppt die Aktivität",
        "Abrechenbar",
      ],
      cancel: "Abbrechen",
      editModalBody: "Mandant Idle bearbeiten",
      confirmEdit: "Bestätigen Sie Bearbeiten",
      deleteModalTitle: "Bestätigen Sie Löschen",
      deleteModalBody: "Sind Sie sicher, dass Sie löschen möchten?",
      confirm: "Speichern",
    },
  },

  AdminUnauthorized: {
    en: {
      header: "Access Denied",
      body: "You do not have permission to view this page.",
      footer: "Check your role's permissions.",
      logOut: "Logout",
    },

    de: {
      header: "Zugriff abgelehnt",
      body: "Sie haben keine Berechtigung, diese Seite anzuzeigen.",
      footer: "Überprüfen Sie die Berechtigungen Ihrer Rolle.",
      logOut: "Ausloggen",
    },
  },

  AdminUserRoles: {
    en: {
      updateSuccessSnackbar: "Updated user role successfully",
      addSuccessSnackbar: "New user added successfully",
      pageName: "User Roles",
      add: "Add",
      addModalHeader: "Add a new user",
      modalLabels: ["Username (email)", "Name", "Role"],
      cancel: "Cancel",
      tableHeaders: ["Name", "Username (email)", "Role"],
      delete: "Delete",
      confirmDelete: "Confirm Deletion",
      confirmDeleteBody:
        "Deleting this user's final role will remove the user from the tenant. Are you sure you want to proceed?",
      duplicateEmailSnackbar: "This user is already assigned to that tenant!",
      first: "First",
      previous: "Previous",
      next: "Next",
      last: "Last",
      page: "Page",
      of: "of",
      items: "items",
      searchHint: "Please fill in more than 3 characters to start searching.",
      searchPlaceholder: "Search by Name",
    },
    de: {
      updateSuccessSnackbar: "Benutzerrolle erfolgreich aktualisiert",
      addSuccessSnackbar: "Neuer Benutzer erfolgreich hinzugefügt",
      pageName: "Rollen / Rechte Verwaltung",
      add: "Hinzufügen",
      addModalHeader: "Fügen Sie einen neuen Benutzer hinzu",
      modalLabels: ["Name", "Benutzername (E-Mail)", "Rolle"],
      cancel: "Abbrechen",
      tableHeaders: ["Benutzername (E-Mail)", "Name", "Rolle"],
      delete: "Löschen",
      confirmDelete: "Löschen bestätigen",
      confirmDeleteBody:
        "Durch das Löschen der letzten Rolle dieses Benutzers wird der Benutzer aus dem Mandanten entfernt. Sind Sie sicher, dass Sie fortfahren möchten?",
      duplicateEmailSnackbar:
        "Dieser Benutzer ist diesem Mieter bereits zugewiesen!",
      first: "Erste",
      previous: "Zurück",
      next: "Nächste",
      last: "Letzte",
      page: "Seite",
      of: "von",
      items: "Einträge",
      searchHint:
        "Bitte geben Sie mehr als 3 Zeichen ein, um mit der Suche zu beginnen.",

      searchPlaceholder: "Suche mit Name",
    },
  },

  AdminUserToTeam: {
    en: {
      pageName: "User-to-Team",
      search: "Search",
      tableHeaders: ["User", "Team", "Admin Team"],
      successSnackbar: "Success! The user was successfully added to the team",
      unassignSnackbar: "Success! The user was successfully unassigned",
      none: "None",
      first: "First",
      previous: "Previous",
      next: "Next",
      last: "Last",
      page: "Page",
      of: "of",
      items: "items",
    },
    de: {
      pageName: "User-Team-Zuordnung",
      search: "Suchen",
      tableHeaders: ["Benutzer", "Team", "Admin-Team"],
      successSnackbar:
        "Erfolg! Der benutzer wurde erfolgreich zum team hinzugefügt",
      unassignSnackbar:
        "Erfolg! Der Benutzer wurde erfolgreich vom Team entfernt",
      none: "Nicht zugwiesen",
      first: "Erste",
      previous: "Zurück",
      next: "Nächste",
      last: "Letzte",
      page: "Seite",
      of: "von",
      items: "Einträge",
    },
  },

  // pending inbound vdns, outbound vdns, previewForm,
  // fieldsection, formsection, forminfo, serviceInfo
  // and possibly some other components (DONE)

  InboundVDNs: {
    en: {
      pageName: "Inbound Queues",
      add: "Add",
      addNewInboundQueue: "Adding a new Inbound Queue",
      editInboundQueue: "Editing inbound Queue",
      cancel: "Cancel",
      confirm: "Confirm",
      deleteConfirmation: "Are you sure you want to delete?",
      name: "Name",
      iniQueue: "INI-Queue",
      lineOfBusiness: "Line of Business",
      createdSuccessfully: "Created new inbound queue successfully",
      editedSuccessfully: "Edited inbound queue successfully",
      deletedSuccessfully: "Deleted inbound queue successfully",
      tableHeaders: ["NAME", "INI-Queue", "Line of Business", "EDIT/DELETE"],
    },
    de: {
      pageName: "Inbound Queues",
      add: "Hinzufügen",
      addNewInboundQueue: "Fügen Sie eine neue Inbound-Queue hinzu",
      editInboundQueue: "Bearbeiten der Inbound-Queue",
      cancel: "Abbrechen",
      confirm: "Speichern",
      deleteConfirmation: "Sind Sie sicher, dass Sie löschen möchten?",
      name: "Name",
      iniQueue: "INI-Queue",
      lineOfBusiness: "Geschäftsbereich",
      createdSuccessfully: "Neue Inbound-Queue erfolgreich erstellt",
      editedSuccessfully: "Inbound-Queue erfolgreich bearbeitet",
      deletedSuccessfully: "Inbound-Queue erfolgreich gelöscht",
      tableHeaders: [
        "NAME",
        "INI-Queue",
        "Geschäftsbereich",
        "BEARBEITEN/LÖSCHEN",
      ],
    },
  },

  OutboundVDNs: {
    en: {
      pageName: "Outbound Queues",
      addNewOutboundQueue: "Adding a new Outbound Queue",
      editOutboundQueue: "Editing Outbound Queue",
      moveUp: "Move Up",
      moveDown: "Move Down",
      add: "Add",
      tableHeaders: [
        "Name",
        "Queue",
        "Telephone Number",
        "Default Number",
        "Line of Business",
        "EDIT/DELETE",
      ],
      name: "Name",
      queue: "Queue",
      telNo: "Telephone Number",
      default: "Default Number",
      lob: "Line of Business",
      cancel: "Cancel",
      confirm: "Confirm",
      areYouSureToDelete: "Are you sure you want to delete?",
      errorEditingVDN: "Error editing VDN: a default number already exists",
      actionSuccessful: "Action successful, saved",
      invalidPhoneNumber: "Invalid phone number",
      yes: "Yes",
      no: "No",
    },
    de: {
      pageName: "Outbound Queues",
      addNewOutboundQueue: "Fügen Sie eine neue Outbound Line hinzu",
      editOutboundQueue: "Editing Outbound Queue",
      moveUp: "Nach oben",
      moveDown: "Nach unten",
      add: "Hinzufügen",
      tableHeaders: [
        "Name",
        "Queue",
        "Telefonnummer",
        "Ist Standard",
        "Geschäftsbereich",
        "BEARBEITEN/LÖSCHEN",
      ],
      name: "Name",
      queue: "Queue",
      telNo: "Telefonnummer",
      default: "Ist Standard",
      lob: "Geschäftsbereich",
      cancel: "Abbrechen",
      confirm: "Speichern",
      areYouSureToDelete: "Sind Sie sicher, dass Sie löschen möchten?",
      errorEditingVDN:
        "Fehler beim Bearbeiten der VDN: Es ist bereits eine Standardnummer vorhanden",
      actionSuccessful: "Aktion erfolgreich, gespeichert",
      invalidPhoneNumber: "Ungültige Telefonnummer",
      yes: "Ja",
      no: "Nein",
    },
  },

  PreviewForm: {
    en: {
      pageName: "Admin page",
      formNamePlaceholder: "Admin page",
      testValidation: "Test Validation",
      closeButtonLabel: "Close",
      fieldsAreValidMessage: "Fields are valid",
      navBarTitle: "Admin page",
      sectionRankSortingOrder: "Ascending order for rank",
    },
    de: {
      pageName: "Administrator Seite",
      formNamePlaceholder: "Administrator Seite",
      testValidation: "Testvalidierung",
      closeButtonLabel: "Schließen",
      fieldsAreValidMessage: "Felder sind gültig",
      navBarTitle: "Administrator Seite",
      sectionRankSortingOrder: "Sortierreihenfolge",
    },
  },

  FormSection: {
    en: {
      sectionNameLabel: "Section Name",
      rankLabel: "Rank",
      visualLabel: "Visual",
      expandedLabel: "Expanded",
      collapsedLabel: "Collapsed",
      helpTextLabel: "Helptext",
      positionLabel: "Section Position in column",
      lastModifiedLabel: "Last modified",
      deleteButtonLabel: "Delete",
      cancelButtonLabel: "Cancel",
      saveButtonLabel: "Save",
      deleteConfirmationMessage: "Are you sure want to delete this section?",
      resetConfirmationMessage:
        "Are you sure want to reset to default/saved values?",
      sectionNamePlaceholder: "Section Name",
      rankPlaceholder: "Rank",
      never: "Never",
    },
    de: {
      sectionNameLabel: "Abschnitt Name",
      rankLabel: "Sortierreihenfolge",
      visualLabel: "Sichtbarkeit",
      expandedLabel: "Ausgeklappt",
      collapsedLabel: "Eingeklappt",
      helpTextLabel: "Hilfstext",
      positionLabel: "Spalte",
      lastModifiedLabel: "Zuletzt bearbeitet",
      deleteButtonLabel: "Löschen",
      cancelButtonLabel: "Abbrechen",
      saveButtonLabel: "Speichern",
      deleteConfirmationMessage:
        "Möchten Sie diesen Abschnitt wirklich löschen?",
      resetConfirmationMessage:
        "Möchten Sie wirklich auf die Standard-/gespeicherten Werte zurücksetzen?",
      sectionNamePlaceholder: "Abschnitt Name",
      rankPlaceholder: "Sortierreihenfolge",
      never: "Niemals",
    },
  },

  FormInfo: {
    en: {
      message: "Invalid date: form active to should be after active from.",
      deleteButtonLabel: "Delete",
      cancelButtonLabel: "Cancel",
      saveButtonLabel: "Save",
      duplicatingFormLabel: "Duplicating form",
      addNewFormLabel: "Add new Form",
      editFormLabel: "Edit form",
      nameLabel: "Name",
      helpTextLabel: "Help text",
      sectionAlignmentLabel: "Section Alignment",
      billableLabel: "Billable",
      activeFromLabel: "Active from",
      numberOfActivationLabel: "Number of activation",
      lastEditedLabel: "Last edited",
      previewButtonLabel: "Preview",
      deleteConfirmationTitle: "Are you sure you want to delete this form?",
      deleteConfirmationBody:
        "This form will be deleted immediately. You can't undo this action.",
      formExistsErrorMessage: "Form with the same name already exists",
      savedSuccessfullyMessage: "Success! Form saved",
      to: "to",
      byUser: " by",
      deleteSnackbarMessage: "Successfully deleted form",
      emptyNameError: "Form name cannot be empty",
    },
    de: {
      message: "Ungültiges Datum.",
      deleteButtonLabel: "Löschen",
      cancelButtonLabel: "Abbrechen",
      saveButtonLabel: "Speichern",
      duplicatingFormLabel: "Formular duplizieren",
      addNewFormLabel: "Neues Formular hinzufügen",
      editFormLabel: "Formular bearbeiten",
      nameLabel: "Name",
      helpTextLabel: "Hilfstext",
      sectionAlignmentLabel: "Abschnitte ausgerichtet",
      billableLabel: "Abrechenbar",
      activeFromLabel: "Aktiv von",
      numberOfActivationLabel: "Anzahl der Aktivitäten",
      lastEditedLabel: "Zuletzt bearbeitet",
      previewButtonLabel: "Vorschau",
      deleteConfirmationTitle: "Möchten Sie den Abschnitt wirklich löschen?",
      deleteConfirmationBody:
        "Dieses Formular wird sofort gelöscht. Sie können diese Aktion nicht rückgängig machen.",
      formExistsErrorMessage: "Formular mit demselben Namen existiert bereits",
      savedSuccessfullyMessage: "Erfolg! Formular gespeichert",
      to: "bis",
      byUser: " von",
      deleteSnackbarMessage: "Formular erfolgreich gelöscht",
      emptyNameError: "Der Formularname darf nicht leer sein",
    },
  },

  ServiceInfo: {
    en: {
      mainContentTitle: "Details",
      loading: "Loading",
      name: "Name",
      uamId: "UAM ID",
      activeFromTo: "Active from to",
      serviceAssignment: "Service Assignment",
      teamAccess: "Team access",
      teamsInherit: "Teams inherit",
      offlineForms: "Offline forms",
      inboundCalls: "Inbound calls",
      outboundCalls: "Outbound calls",
      lastEdited: "Last edited",
      save: "Save",
      successfullySaved: "Successfully saved service",
      invalidVdn:
        "Cannot assign this VDN as it hasn't been assigned to a line of business",
      confirmationMessage: "Are you sure you want to remove this form?",
      removeFormExplanation: "This form will be removed from this service.",
      cancel: "Cancel",
      ok: "OK",
      formName: "FORM NAME",
      editRemove: "EDIT/REMOVE",
      inboundLineName: "INBOUND LINE NAME",
      line: "LINE",
      add: "Add",
      edit: "Edit",
      remove: "REMOVE",
      yes: "Yes",
      no: "No",
      addOfflineModalTitle: "Add offline form",
      addInboundModalTitle: "Add inbound form",
      addOutboundModalTitle: "Add outbound form",
      lastEdited: "Last edited: ",
      byUser: " by",
      invalidInfoMessage:
        "Cannot continue without filling in required information",
      delete: "Delete",
      deleteServiceConfirm: "Successfully deleted service",
      confirmDeleteModalTitle: "Confirm Deletion",
      confirmDeleteModalBody: "Are you sure you want to delete?",
      delete: "Delete",
    },
    de: {
      mainContentTitle: "Details",
      loading: "Wird geladen",
      name: "Name",
      uamId: "UAM ID",
      activeFromTo: "Aktiv von bis",
      serviceAssignment: "Service-Zuweisung",
      teamAccess: "Teamzugang",
      teamsInherit: "Teams vererben",
      offlineForms: "Offline-Formulare",
      inboundCalls: "Formular für eingehende Anrufe",
      outboundCalls: "Formular für ausgehende Anrufe",
      lastEdited: "Zuletzt bearbeitet",
      save: "Speichern",
      successfullySaved: "Dienst erfolgreich gespeichert",
      invalidVdn:
        "Diese VDN kann nicht zugewiesen werden, da sie keinem Geschäftsbereich zugewiesen wurde",
      confirmationMessage: "Möchten Sie dieses Formular wirklich entfernen?",
      removeFormExplanation: "Dieses Formular wird aus diesem Dienst entfernt.",
      cancel: "Abbrechen",
      ok: "OK",
      formName: "FORMULARNAME",
      editRemove: "BEARBEITEN/ENTFERNEN",
      inboundLineName: "Name der Inbound-Queue",
      line: "LINIE",
      add: "Hinzufügen",
      edit: "Bearbeiten",
      remove: "ENTFERNEN",
      yes: "Ja",
      no: "Nein",
      addOfflineModalTitle: "Offline-Formular hinzufügen",
      addInboundModalTitle: "Formular für eingehende Anrufe hinzufügen",
      addOutboundModalTitle: "Formular für ausgehende Anrufe hinzufügen",
      lastEdited: "Zuletzt bearbeitet: ",
      byUser: " vom",
      invalidInfoMessage:
        "Ohne Eingabe der erforderlichen Informationen kann nicht fortgefahren werden",
      delete: "Löschen",
      deleteServiceConfirm: "Dienst erfolgreich gelöscht",
      confirmDeleteModalTitle: "Löschen bestätigen",
      confirmDeleteModalBody: "Sind Sie sicher, dass Sie löschen möchten?",
      delete: "Löschen",
    },
  },

  Tags: {
    en: {
      assignedTeams: "Assigned Teams",
    },
    de: {
      assignedTeams: "Zugewiesene Teams",
    },
  },

  DropdownSearch: {
    en: {
      all: "Add All",
      clear: "Clear",
      itemsSelected: " items Selected",
    },
    de: {
      all: "Alle Zugewiesen",
      clear: "Auswahl aufheben",
      itemsSelected: " Elemente ausgewählt",
    },
  },

  ContextMenu: {
    en: {
      addSection: "Add Section",
      duplicateForm: "Duplicate Form",
      addField: "Add Field",
      deleteSection: "Delete Section",
      deleteField: "Delete field",
    },
    de: {
      addSection: "Abschnitt hinzufügen",
      duplicateForm: "Doppeltes Formular",
      addField: "Feld hinzufügen",
      deleteSection: "Abschnitt löschen",
      deleteField: "Feld löschen",
    },
  },

  FieldSection: {
    en: {
      fieldType: "Field Type",
      spec: "Specification",
      helpText: "Help Text",
      required: "Required",
      inactive: "Inactive",
      memory: "Memory Field",
      displayAgent: "Display in agent activities",
      displayIntra: "Display in intraday view",
      search: "Search in edit records",
      rank: "Rank",
      unit: "Unit",
      parent: "Parent",
      notSelected: "Not Selected",
      delete: "Delete",
      cancel: "Cancel",
      save: "Save",
      deleteConfirmation: "Are you sure want to delete this field?",
      resetConfirmation: "Are you sure want to reset to default/saved values?",
      promptMessage: "Unsaved changes detected, continue?",
    },
    de: {
      fieldType: "Typ",
      spec: "Spezifikation",
      helpText: "Hilfstext",
      required: "Erforderlich",
      inactive: "Inaktiv",
      memory: "Wert merken",
      displayAgent: "In Agentenaktivitäten anzeigen",
      displayIntra: "Anzeige in der Intraday-Ansicht",
      search: "Suchen Sie in Bearbeitungsdatensätzen",
      rank: "Sortierreihenfolge",
      unit: "Einheit",
      parent: "Übergeordnetes Feld",
      notSelected: "Nicht ausgewählt",
      delete: "Löschen",
      cancel: "Abbrechen",
      save: "Speichern",
      deleteConfirmation: "Möchten Sie dieses Feld wirklich löschen?",
      resetConfirmation:
        "Möchten Sie wirklich auf die Standard-/gespeicherten Werte zurücksetzen?      ",
      promptMessage:
        "Es wurden nicht gespeicherte Änderungen erkannt. Fortfahren?",
    },
  },

  LobInfo: {
    en: {
      successEditMessage: "Successfully edited LoB name",
      successAddMessage: "Successfully added new LoB",
      successDeleteMessage: "Successfully deleted LoB: ",
      deleteModalTitle: "Are you sure you want to delete this LoB?",
      deleteModalBody:
        "This LoB will be deleted immediately. You can't undo this action.",
      cancel: "Cancel",
      delete: "Delete",
      duplicatedLoBName: "Line of Business name already exists.",
    },
    de: {
      successEditMessage: "Der Geschäftsbereich wurde erfolgreich bearbeitet",
      successAddMessage: "Neuer Geschäftsbereich erfolgreich hinzugefügt",
      successDeleteMessage: "Geschäftsbereich erfolgreich gelöscht: ",
      deleteModalTitle:
        "Sind Sie sicher, dass Sie diesen Geschäftsbereich löschen möchten?",
      deleteModalBody:
        "Dieser Geschäftszweig wird umgehend gelöscht. Sie können diese Aktion nicht rückgängig machen.",
      cancel: "Abbrechen",
      delete: "Löschen",
      duplicatedLoBName: "Der Name des Geschäftsbereichs existiert bereits.",
    },
  },

  AdminTenantManagement: {
    en: {
      addNew: "Add a new tenant",
      activated: "Activated tenant successfully",
      deactivated: "Deactivated tenant successfully",
      created: "Created new tenant successfully",
      editedSuccess: "Edited tenant successfully",
      name: "Tenant Name",
      add: "Add",
      close: "Close",
      saveChanges: "Save Changes",
      editingTitle: "Editing tenant name",
      pageTitle: "Tenant Management",
      tableHeaders: ["Tenant ID", "Tenant Name", "Active", "Edit", "Switch"],
      switch: "Switch",
      deactivationModalTitle: "Deactivation Warning",
      deactivationModalBody:
        "Deactivating this tenant will make it inactive in the tenant list, and will prevent it from accessing the platform",
      deactivate: "Deactivate",
    },
    de: {
      addNew: "Fügen Sie einen neuen Mieter hinzu",
      activated: "Mieter erfolgreich aktiviert",
      deactivated: "Mieter erfolgreich deaktiviert",
      created: "Neuer Mieter erfolgreich erstellt",
      editedSuccess: "Mieter erfolgreich bearbeitet",
      name: "Mietername",
      add: "Hinzufügen",
      close: "Schließen",
      saveChanges: "Speichern",
      editingTitle: "Mieter bearbeiten",
      pageTitle: "Mieterverwaltung",
      tableHeaders: [
        "Mandant-ID",
        "Mandanten Name",
        "Aktiv",
        "Bearbeiten",
        "Wechseln",
      ],
      switch: "Wechseln",
      deactivationModalTitle: "Deaktivierungswarnung",
      deactivationModalBody:
        "Durch die Deaktivierung dieses Mandanten wird er in der Mandantenliste inaktiv und kann nicht auf die Plattform zugreifen",
      deactivate: "Deaktivieren",
    },
  },

  AdminMasterIdles: {
    en: {
      addedSuccess: "Added new master idle successfully",
      modifiedSuccess: "Modified master idle successfully",
      pageTitle: "Master Idles",
      add: "Add",
      addModalTitle: "Add Master Idle",
      name: "Name",
      cancel: "Cancel",
      editModalTitle: "Edit Master Idle",
      edit: "Edit",
      confirmDeleteModalTitle: "Confirm Delete Master Idle",
      confirmDeleteModalBody:
        "WARNING: Deleting this master idle will delete all its associated tenant idles in tenants: ",
      delete: "Delete",
      deleteSnackbarMessage: "Deleted master idle successfully",
      tableHeaders: [
        "Name",
        "Created",
        "Modified",
        "Created by",
        "Modified by",
        "Edit",
        "Delete",
      ],
    },
    de: {
      addedSuccess: "Master idle erfolgreich hinzugefügt",
      modifiedSuccess: "Master idle erfolgreich bearbeitet",
      pageTitle: "Master Idles",
      add: "Hinzufügen",
      addModalTitle: "Master Idle hinzufügen",
      name: "Name",
      cancel: "Abbrechen",
      editModalTitle: "Master Idle bearbeiten",
      edit: "Bearbeiten",
      confirmDeleteModalTitle: "Master Idle löschen",
      confirmDeleteModalBody:
        "WARNUNG: Wenn Sie diesen Master Idle löschen, werden alle zugehörigen Tenant Idles gelöscht in Mandanten: ",
      delete: "Löschen",
      deleteSnackbarMessage: "Master idle erfolgreich gelöscht",
      tableHeaders: [
        "Name",
        "Erstellt",
        "Geändert",
        "Erstellt von",
        "Geändert von",
        "Bearbeiten",
        "Löschen",
      ],
    },
  },

  // TODO: find out any other components I might have missed out on and figure out what to do
  // in regards to any dates that might not be formatted

  // {strings[pageTitle][language].pageName}

  // agent strings

  AgentHomePage: {
    en: {
      PersonalStatisticsHeader: "Personal Statistics",
      PersonalStatisticsToday: "Today",
      PersonalStatisticsYesterday: "Yesterday",
      PersonalStatisticsTotalProcesTime: "Total Process Time (incl. idle)",
      PersonalStatisticsNetProcessTime: "Net Process Time (excl. idle)",
      PersonalStatisticsTotalIdleTime: "Total Idle Time",
      PersonalStatisticsOfflineActivities: "Offline Activities",
      PersonalStatisticsTeam: "TEAM",
      PersonalStatisticsService: "SERVICE",
      PersonalStatisticsForm: "FORM",
      PersonalStatisticsDuration: "DURATION",
      PersonalStatisticsCount: "COUNT",
      PersonalStatisticsAht: "AHT",
      PersonalStatisticsCallActivities: "Call Activities",
      PersonalStatisticsTypeOfCall: "TYPE OF CALL",
      PersonalStatisticsIdleAct: "Idle Activities",
      PersonalStatisticsIdleCode: "IDLE CODE",
      PersonalStatisticsOk: "Ok",

      MyOfflineActivitiesHeader: "My Offline Activities",
      MyOfflineActivitiesFilterBy: "Filter by",
      MyOfflineActivitiesServices: "Services",
      MyOfflineActivitiesForms: "FORMS",
      MyOfflineActivitiesBillable: "Billable/Not billable",
      MyOfflineActivitiesFinalized: "Finalized/Not finalized",
      MyOfflineActivitiesTrackedVol: "Tracked Volumes",
      MyOfflineActivitiesFomr: "FORM",
      MyOfflineActivitiesSection: "SECTION",
      MyOfflineActivitiesField: "FIELD",
      MyOfflineActivitiesChoice: "CHOICE",
      MyOfflineActivitiesVal: "VALUE",
      MyOfflineActivitiesUnit: "UNIT",
      MyOfflineActivitiesDuration: "DURATION",
      MyOfflineActivitiesNumAct: "NUMBER OF PROCESSES",
      MyOfflineActivitiesAht: "AHT",
      MyOfflineActivitiesOk: "Ok",
      FromDate: "Start date",
      ToDate: "End date",
      billableTypes: [
        {
          name: "Billable/Not Billable",
          value: null,
        },
        {
          name: "Billable",
          value: true,
        },
        {
          name: "Not Billable",
          value: false,
        },
      ],
      finalizedTypes: [
        {
          name: "Finalized/Not Finalized",
          value: null,
        },
        {
          name: "Finalized",
          value: true,
        },
        {
          name: "Not finalized",
          value: false,
        },
      ],
    },
    de: {
      PersonalStatisticsHeader: "Persönliche Statistik",
      PersonalStatisticsToday: "Heute",
      PersonalStatisticsYesterday: "Gestern",
      PersonalStatisticsTotalProcesTime:
        "Brutto-Prozesszeit (inkl. Idle-Zeiten)",
      PersonalStatisticsNetProcessTime: "Netto-Prozesszeit (exkl. Idle-Zeiten)",
      PersonalStatisticsTotalIdleTime: "Idlezeit (gesamt)",
      PersonalStatisticsOfflineActivities: "Offline-Aktivitäten",
      PersonalStatisticsTeam: "TEAM",
      PersonalStatisticsService: "SERVICE",
      PersonalStatisticsForm: "FORMULAR",
      PersonalStatisticsDuration: "DAUER",
      PersonalStatisticsCount: "ZAHL",
      PersonalStatisticsAht: "AHT",
      PersonalStatisticsCallActivities: "Anruf-Aktivitäten",
      PersonalStatisticsTypeOfCall: "ART DES ANRUFS",
      PersonalStatisticsIdleAct: "Idle Aktivitäten",
      PersonalStatisticsIdleCode: "IDLE CODE",
      PersonalStatisticsOk: "Ok",

      MyOfflineActivitiesHeader: "Meine Offline-Aktivitäten",
      MyOfflineActivitiesFilterBy: "Filtern nach",
      MyOfflineActivitiesServices: "Services",
      MyOfflineActivitiesForms: "Formulare",
      MyOfflineActivitiesBillable: "Abrechenbar/Nicht abrechenbar",
      MyOfflineActivitiesFinalized: "Abgeshlossen/Nicht abgeschlossen",
      MyOfflineActivitiesTrackedVol: "erfasste Mengen",
      MyOfflineActivitiesFomr: "FORMULAR",
      MyOfflineActivitiesSection: "ABSCHNITT",
      MyOfflineActivitiesField: "FELD",
      MyOfflineActivitiesChoice: "WAHL",
      MyOfflineActivitiesVal: "EINHEIT",
      MyOfflineActivitiesUnit: "UNIT",
      MyOfflineActivitiesDuration: "DAUER",
      MyOfflineActivitiesNumAct: "ANZAHL DER PROZESSE",
      MyOfflineActivitiesAht: "AHT",
      MyOfflineActivitiesOk: "Ok",
      FromDate: "Start Datum",
      ToDate: "Ende Datum",
      billableTypes: [
        {
          name: "Abrechenbar/Nicht abrechenbar",
          value: null,
        },
        {
          name: "Abrechenbar",
          value: true,
        },
        {
          name: "Nicht abrechenbar",
          value: false,
        },
      ],
      finalizedTypes: [
        {
          name: "Abgeschlossen/Nicht Abgeschlossen",
          value: null,
        },
        {
          name: "Abgeschlossen",
          value: true,
        },
        {
          name: "Nicht Abgeschlossen",
          value: false,
        },
      ],
    },
  },
  AgentFormsAndServices: {
    en: {
      ChangeFormMessage:
        "Changing the form will clear all not saved fields. Do you want to continue?",
      Yes: "Yes",
      No: "No",
      CantStartForm: "Cannot start a form while a call form is running",
    },
    de: {
      ChangeFormMessage:
        "Durch Ändern des Formulars werden alle nicht gespeicherten Felder gelöscht. Möchten Sie fortfahren?",
      Yes: "Ja",
      No: "Nein",
      CantStartForm:
        "Ein Formular kann nicht gestartet werden, während ein Anrufformular ausgeführt wird",
    },
  },

  FormsView: {
    en: {
      Today: "Today",
      DayTotalAct: "DAY TOTAL ACTIVITIES",
      DayTotalTime: "CAYCI Activity Time",
      IncBreaks: "incl. Breaks",
      ActivityType: "ACTIVITY TYPE",
      Service: "SERVICE",
      FormAct: "FORM/ACTIVITY",
      PhoneNum: "PHONE NUMBER",
      INFO: "INFO",
      Line: "LINE",
      Billable: "BILLABLE",
      Time: "TIME",
      Duration: "DURATION",
      TypeMsg: "Type to filter...",
      ChooseLine: "Choose a line...",
      Line: "LINE",
      FormSavedMessage: "Form saved successfully",
      CantStartForm: "Cannot start a form while a call form is running",
    },
    de: {
      Today: "HEUTE",
      DayTotalAct: "TAGESGESAMTAKTIVITÄTEN",
      DayTotalTime: "TAGESGESAMTZEIT",
      IncBreaks: "inkl. Pausen",
      ActivityType: "AKTIVITÄTSTYP",
      Service: "SERVICE",
      FormAct: "FORMULAR / AKTIVITÄT",
      PhoneNum: "TELEFONNUMMER",
      INFO: "INFO",
      Line: "LEITUNG",
      Billable: "ABRECHENBAR",
      Time: "ZEIT",
      Duration: "DAUER",
      TypeMsg: "Typ zum Filtern...",
      ChooseLine: "Wähle eine Leitung...",
      Line: "LEITUNG",
      FormSavedMessage: "Formular erfolgreich gespeichert",
      CantStartForm:
        "Ein Formular kann nicht gestartet werden, während ein Anrufformular ausgeführt wird",
    },
  },

  FormRowData: {
    en: {
      OfflineAct: "OFFLINE ACTIVITY",
      InCall: "INCOMING CALL",
      OutCall: "OUTGOING CALL",
      AssignedForm: "Assigned form:",
      DeleteMsgHeader: "Are you sure you want to delete this process?",
      DeleteProcessTimeHeader:
        "Are you sure you want to delete this process time?",
      DeleteMsgBody:
        "This process will be deleted immediately. You can't undo this action.",
      DeleteMsgCancel: "Cancel",
      DeleteMsgDelete: "Delete",
      Save: "Save",
      SaveAndNew: "Save And New",
    },
    de: {
      OfflineAct: "OFFLINE-AKTIVITÄT",
      InCall: "Eingehender Anruf",
      OutCall: "Ausgehender Anruf",
      AssignedForm: "Zugewiesenes Formular:",
      DeleteMsgHeader:
        "Sind Sie sicher, dass Sie diesen Prozess löschen möchten?",
      DeleteProcessTimeHeader:
        "Sind Sie sicher, dass Sie diese Prozesszeit löschen möchten?",
      DeleteMsgBody:
        "Dieser Vorgang wird sofort gelöscht. Sie können diese Aktion nicht rückgängig machen.",
      DeleteMsgCancel: "Abbrechen",
      DeleteMsgDelete: "Löschen",
      Save: "Speichern",
      SaveAndNew: "Speichern und Neu",
    },
  },
};

export default localization;
